import gql from "graphql-tag";

const VELOCITY_REPORTKML_QUERY = gql`
  query VelocityReportKML(
    $assetsSelected: [Int]!
    $fechaInicio: Datetime
    $fechaFin: Datetime
    $driversSelected: [Int]
    $velocidadDesde: Float
    $velocidadHasta: Float
    $days: [WeekDaysEnum]
  ) {
    velocityReportKML(
      assetsSelected: $assetsSelected
      fechaInicio: $fechaInicio
      fechaFin: $fechaFin
      driversSelected: $driversSelected
      velocidadDesde: $velocidadDesde
      velocidadHasta: $velocidadHasta
      days: $days
    )
  }
`;

export default VELOCITY_REPORTKML_QUERY;
